import React, { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import TextSubmissionDrawerContent from './content/TextSubmissionDrawerContent'
import { useDispatch, useSelector } from 'react-redux'
import { submissionActions } from '../../../../store/slices/submission.slice'
import { Drawer, Form, Skeleton, theme } from 'antd'
import './text-submission-drawer.scss'
import submissionSelectors from '../../../../store/selectors/submission.selectors'
import TextSubmissionDrawerHeader from './header/TextSubmissionDrawerHeader'
import TextSubmissionDrawerExtra from './header/TextSubmissionDrawerExtra'
import { useApprovalSpeedCleanup } from '../../../../hooks/useApprovalSpeedAnalytics'
import { useCloseAndNavigateToDashboard } from '../../../../store/apis/utils/hooks/text-submission.hooks'
import useQueryParam from '../../../../hooks/useQueryParam'
import { FLAGGED_PARAM } from '../../../../constants/query-params'

const TextSubmissionDrawer = () => {
    const { token: themeToken } = theme.useToken()
    const dispatch = useDispatch()
    const someSubmissionIsOpened = useSelector(submissionSelectors.someIsOpened)
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const [animationOfDrawerHasFinished, setAnimationOfDrawerHasFinished] = useState(false)
    const isInFlaggedMode = useQueryParam(FLAGGED_PARAM) === 'true'
    
    useApprovalSpeedCleanup()

    const closeAndNavigateToDashboard = useCloseAndNavigateToDashboard()

    const handleClose = async () => {
        await closeAndNavigateToDashboard()
        
        if (!isInFlaggedMode) {
            dispatch(submissionActions.closeSubmission())
            setAnimationOfDrawerHasFinished(false)
        }
    }

    const content = (
        <div style={{ position: 'relative', overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Form name='review-submission' layout='vertical' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <AnimatePresence mode='wait'>
                    <motion.div
                        key={openedSubmissionId}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                    >
                        <TextSubmissionDrawerContent submissionId={openedSubmissionId} />
                    </motion.div>
                </AnimatePresence>
            </Form>
        </div>
    )

    return someSubmissionIsOpened ? (
        <Drawer
            autofocus
            rootClassName='text-submission-drawer'
            title={<TextSubmissionDrawerHeader />}
            placement='right'
            onClose={handleClose}
            destroyOnClose
            open={true}
            mask={false}
            maskClosable={false}
            width='100%'
            extra={<TextSubmissionDrawerExtra />}
            afterOpenChange={open => setAnimationOfDrawerHasFinished(open)}
            getContainer={false}
            styles={{
                content: {
                    borderRadius: themeToken.borderRadiusLG,
                    overflow: 'hidden',
                },
            }}
        >
            {animationOfDrawerHasFinished ? content : <Skeleton active />}
        </Drawer>
    ) : null
}

export default TextSubmissionDrawer
